module.exports = "/packs/4-10539d9d64f7bd08c4482612cc9a9704.svg";